import React, { useEffect, useState } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { useNavigate } from "@reach/router"
import userStore from '../common/userStore'
import useTitle from '../../hooks/title'
import classes from './Packs.module.scss'
import Button from '@mui/material/Button';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
// import MenuIcon from '@mui/icons-material/Menu';
// import Slide from '@mui/material/Slide';
// import {ReactComponent as RightIcon} from '../../images/right.svg'
// import {ReactComponent as MenuIcon} from '../../images/mb/menu.svg'
import clsx from 'clsx'

import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import usePackPlayer from '../common/usePackPlayer'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import CloseIcon from '@mui/icons-material/Close';
// import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import useWindowSize from '../../hooks/window-size'

import Header from '../header/Header'
import Footer from '../footer/Footer'
import CookieAgree from './CookieAgree'

import { scroll } from '../../utils'
import { useLocation } from "@reach/router"
import Video, {useVideo} from '../help/video';

// function scroll(currentY, targetY) {
//   // 计算需要移动的距离
//   let needScrollTop = targetY - currentY
//   let _currentY = currentY
//   setTimeout(() => {
//     // 一次调用滑动帧数，每次调用会不一样
//     const dist = Math.ceil(needScrollTop / 10)
//     _currentY += dist
//     window.scrollTo(_currentY, currentY)
//     // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
//     if (needScrollTop > 10 || needScrollTop < -10) {
//       scroll(_currentY, targetY)
//     } else {
//       window.scrollTo(_currentY, targetY)
//     }
//   }, 1)

// }


const WelcomePack = observer(({handleNav, pack}) => {
  // const {isPlaying, playPack} = usePackPlayer()
  const navigate = useNavigate();
  const onPlay = () => {
    // playPack(pack)
    navigate(`/pack/${pack.url}`)
  }
  // const playing = isPlaying(pack)
  //console.log(pack.image)
  return <div className={classes.seg5Pack}>
    <div className={classes.seg5PackImg} style={{backgroundImage: `url(${pack.cover})`}} onClick={onPlay}>
      {/* <div className={clsx(classes.seg5PackHover, playing && classes.packPlaying )}>
        {playing ? <PauseCircleFilledIcon className={classes.packPlayBtn} /> : <PlayCircleFilledIcon className={classes.packPlayBtn} />}
      </div> */}
    </div>
    <h2>{pack.title}</h2>
    {/* <a href="/auth/signup" onClick={handleNav}>Try for free <RightIcon /></a> */}
  </div>
})

const Packs = observer(() => {
  useTitle("Sample Packs — Guitar, Drums & Vocal Loops", "Browse Session Loops' royalty-free sample packs. AI-curated guitar loops, drum samples, and vocal loops for music producers.", "/packs")
  const location = useLocation();
  useEffect(() => {
      window.scrollTo(0, 0)
  }, [location.pathname])
  const navigate = useNavigate();
  const [fixHeader, setFixHeader] = useState(false)
  const windowSize = useWindowSize();
  const videoModel = useVideo();
  // const packs = [{
  //   id: '1',
  //   cover: 'https://sessionloops-usa.oss-us-west-1.aliyuncs.com/packs/nylon-dreams/cover.png',
  //   title: 'Nylon Dreams',
  //   tag: "Acounstic/RnB/Hip Hop",
  //   url: 'Nylon-Dreams'
  // }, {
  //   id: '2',
  //   cover: 'https://sessionloops-usa.oss-us-west-1.aliyuncs.com/packs/are-and-be/cover.png',
  //   title: 'Are & Be',
  //   tag: "RnB",
  //   url: 'Are-%26-Be'
  // }, {
  //   id: '3',
  //   cover: 'https://sessionloops-usa.oss-us-west-1.aliyuncs.com/packs/lingering-light-of-the-setting-sun/cover.png',
  //   title: 'Lingering Light of the Setting Sun',
  //   tag: "Neo-Soul/Gospel",
  //   url: 'Lingering-Light-of-the-Setting-Sun'
  // }, {
  //   id: '4',
  //   cover: 'https://sessionloops-usa.oss-us-west-1.aliyuncs.com/packs/the-past-is-no-longer-recalled/cover.png',
  //   title: 'The Past is No Longer Recalled',
  //   tag: "Neo-Soul",
  //   url: 'The-Past-is-No-Longer-Recalled'
  // }]

  useEffect(() => {
    if (userStore.isLogin) {
      navigate('/', {replace: true})
    }
  }, [userStore.isLogin])

  useEffect(() => {
    const t = setInterval(() => {
      setFixHeader(window.scrollY > 75)
    }, 350)
    return () => {
      clearInterval(t)
    }
  }, [])

  const handleNav = (e) => {
    e.preventDefault()
    navigate(e.target.href)
  }

  const nextPage = (e) => {
    const currentY = document.documentElement.scrollTop || document.body.scrollTop
    // window.scrollTo(0, windowSize.height)
    scroll(currentY, windowSize.height)
  }

  return <div className={classes.root}>
      <Header fix={fixHeader} />
      
      <section className={classes.seg1}>
        <div className={classes.mainInfo}>
          <div className={classes.creativity}></div>
          <div className={classes.your}>Your</div>
          <div className={classes.will}>Will</div>
          <div className={classes.limited}>NEVER BE LIMITED</div>
          <div className={classes.mainLine}></div>
          <div className={classes.moreInfo}>Unlimited customizable loops based on grooves, chord changes, effects, and more.</div>
          <Button variant="contained" disableElevation className={classes.started}  onClick={() => navigate('/auth/signup')}>Get Started</Button>
          <div className={classes.video}>
              <div className={classes.button} onClick={videoModel.show}>
                <PlayArrowIcon style={{fontSize: 36, color: '#FF651A'}}/>
              </div>
          </div>
          {/* <a className={classes.learnMore} onClick={nextPage}>Learn more</a>
          <div className={classes.learnMoreArrows} onClick={nextPage}>
            <ExpandMoreIcon className={classes.learnMoreArrow1} />
            <ExpandMoreIcon />
          </div> */}
        </div>
      </section>
      <section className={classes.seg2}>
        <div className={classes.seg2Left}></div>
        <div className={classes.seg2Right}>
          <div className={classes.seg2Info}>
          Build Perfect Loops in Seconds 
          </div>
          <div className={classes.seg2Desc}>
          Drag & drop Groove and Lick clips. Customize chord changes, registers, or apply fills at your will.
          </div>
        </div>
      </section>
      <section className={classes.seg3}>
        <div className={classes.seg3Pop}></div>
        <h2 className={classes.seg3Title}>Chord Progression Library </h2>
        <div className={classes.seg3Desc}>
        Get inspired by hundreds of chord progressions. <br /> Modify or directly apply them to your projects.
        </div>
      </section>
      <section className={classes.seg4}>
        <div className={classes.seg4Wrap}>
          <div className={classes.seg4LeftTop}></div>
          <div className={classes.seg4Main}></div>
          <div className={classes.seg4Wave}></div>
          <h2 className={classes.seg4Title}>
          Add Some Cool Effects
          </h2>
          <div className={classes.seg4Desc}>
          Want a different layer of sound? Try out our FX chains ranging from basic Cloud Reverb, Analog Echo to creative Reversing Machine and Sweep Delay.
          </div>
        </div>
      </section>
      <section className={classes.seg5}>
        <div className={classes.seg5Left}>Live<br />Performance<Button variant="contained" disableElevation className={classes.browse}  onClick={() => navigate('/catalog/live-performance')}>Browse Packs</Button></div>
        <div className={classes.seg5Right}>Producer<br />Sounds<Button variant="contained" disableElevation className={classes.browse}  onClick={() => navigate('/catalog/producer-sounds')}>Browse Packs</Button></div>
      </section>
      <section className={classes.testimonials}>
        What Industry Pros Are Saying About Us
        <div className={classes.testimonialsContent}>
          <div className={classes.testimonial}>
            <div className={classes.reid} />
            <div className={classes.testimonialContent}>
            This is really unique...You can change the sounds that you're hearing and completely dial in your perfect sample before you even download it and drop it into your DAW
              <div className={classes.testimonialName}>
                Reid Stefan, Famous Music Production Youtuber, Realest Puppet in the Game
              </div>
            </div>
          </div>
          <div className={classes.testimonial}>
            <div className={classes.taetro} />
            <div className={classes.testimonialContent}>
              Change what even happens within the loops, make them sound actually natual ... I think you're actually really gonna like it.
              <div className={classes.testimonialName}>
                TAETRO, Electronic Music Producer
              </div>
            </div>
          </div>
          <div className={classes.testimonial}>
            <div className={classes.patrick} />
            <div className={classes.testimonialContent}>
            Some really unique and usable features that i haven't really seen on a platform like this...Took all the chords made them fit the new key that's really cool
              <div className={classes.testimonialName}>
                Patrick Breen, Artist • Producer • Guitarist
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className={classes.seg5}>
        <h1 className={classes.seg5Title}>Check Our Packs</h1>
        <div className={classes.seg5Packs}>
          {packs.map(pack => {
            return <WelcomePack key={pack.id} handleNav={handleNav} pack={pack} />
          })}
        </div>
        <div className={classes.seg5Footer}>
        <Button variant="contained" disableElevation className={classes.browse}  onClick={() => navigate('/catalog')}>Browse All Packs</Button>
        </div>
      </section>  */}
      {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/LdPCVX2Sz1g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <footer>
        <div className={classes.footerLeft}>
          <div className={classes.copyright}>© 2021 Session Loops, Inc. All rights reserved</div>
          <div className={classes.policies}>
            <a href="/policies/terms-of-service" onClick={handleNav}>Terms of Service</a>
            <a href="/policies/privacy-policy" onClick={handleNav}>Privacy Policy</a>    
            <a href="mailto:contact@sessionloops.com">Contact</a>
            <a className={classes.faq} href="/help/faq" onClick={handleNav}>FAQ</a>    
          </div>
        </div>
        <div className={classes.footerRight}>
          <a href="https://www.facebook.com/SessionLoops" target="_blank"><FacebookIcon /></a>
          <a href="https://twitter.com/SessionLoops" target="_blank"><TwitterIcon /></a>
          <a href="https://www.youtube.com/channel/UCy-OnrvyjS9QyNwUQhd6Okw" target="_blank"><YouTubeIcon /></a>
          <a href="https://instagram.com/session_loops" target="_blank"><InstagramIcon /></a>
        </div>
      </footer> */}
      <Footer />
      <Video open={videoModel.open} onClose={videoModel.hide} />
      {/* <CookieAgree /> */}
    </div>
})

export default Packs